module.exports = __webpack_public_path__ + "static/media/Dark-logo-copy.6eaecd36.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/controls/navbar/Dark-logo-copy.png
// module id = 735
// module chunks = 0